var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject } from 'mobx-react';
import { loading } from '../../../elements/Loading';
import { Table } from '../../../components';
import history from '../../../helpers/History';
var CollaboratorPacketsTable = /** @class */ (function (_super) {
    __extends(CollaboratorPacketsTable, _super);
    function CollaboratorPacketsTable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CollaboratorPacketsTable.prototype.render = function () {
        var collaboratorPackets = this.props.collaboratorPackets;
        console.log('CollaboratorPacketsTable - collaboratorPackets: ', collaboratorPackets);
        var headers = ['operatorName', 'name'];
        return (React.createElement("div", null,
            React.createElement(Table, { keyExtractor: function (item) { return String(item.id); }, items: collaboratorPackets, header: headers, onSelectItem: function (value) {
                    history.push("/collaboratorpackets/".concat(value.operator_id, "/").concat(value.id));
                } }),
            React.createElement("div", { style: {
                    width: '100%',
                    position: 'absolute',
                    bottom: 0,
                    // borderBottom: `${Theme.size.hairline} solid ${Theme.color.hairline}`,
                } })));
    };
    CollaboratorPacketsTable = __decorate([
        inject('store'),
        loading(function (props) {
            return [
                props.store.collaboratorPacketsStore.read().then(function (collaboratorPackets) { return ({ collaboratorPackets: collaboratorPackets }); })
            ];
        })
    ], CollaboratorPacketsTable);
    return CollaboratorPacketsTable;
}(Component));
export default CollaboratorPacketsTable;



//////////////////
// WEBPACK FOOTER
// ./src/modules/CollaboratorPackets/container/CollaboratorPacketsTable.tsx
// module id = 1596
// module chunks = 0